import { func, string } from 'prop-types'
import { Size } from '@opallabs/gem'
import { Button, kuiperClassNames, TextArea, Tooltip } from '@opallabs/kuiper'
import { AnalyticsLayer } from '@opallabs/quanta'

import './styles.scss'

const ApprovalControls = ({ approve, decline, feedback, setFeedback }) => (
  <div className={kuiperClassNames('approval-controls')}>
    <TextArea
      aside={true}
      autoFocus={false} // eslint-disable-line jsx-a11y/no-autofocus
      className={kuiperClassNames('feedback-input')}
      focusOnMount={false}
      maxLength={500}
      minRows={1}
      onChange={(value) => setFeedback(value)}
      placeholder="Feedback optional if approving this phase"
      strict={true}
      truncate={true}
      valid={true}
      value={feedback}
    />
    <AnalyticsLayer name={`Approve${feedback ? ' with feedback' : ''}`}>
      <Tooltip
        className="save-and-approve"
        content="Save and Approve"
        popoverHandlers={{
          interactive: false,
        }}
        theme="dark"
        trigger={
          <Button
            ariaLabel="Approve"
            color="green"
            icon="gem-thumbs-up"
            iconOptions={{
              ariaMode: 'hidden',
              height: Size.Icon,
              system: 'gem',
              width: Size.Icon,
            }}
            onClick={approve}
          />
        }
      />
    </AnalyticsLayer>
    <AnalyticsLayer name="Decline">
      <Button
        ariaLabel="Decline"
        color="red"
        disabled={!feedback}
        icon="gem-thumbs-down"
        iconOptions={{
          ariaMode: 'hidden',
          height: Size.Icon * 0.875,
          system: 'gem',
          width: Size.Icon * 0.875,
        }}
        onClick={decline}
      />
    </AnalyticsLayer>
  </div>
)

ApprovalControls.propTypes = {
  approve: func,
  decline: func,
  feedback: string,
  setFeedback: func,
}

export default ApprovalControls
